import { UserAvatar } from "@cmp-src/data-display/UserAvatar/UserAvatar";
import React from "react";
import type { NavUserAvatarProps } from "./types";

export const NavUserAvatar: React.FC<NavUserAvatarProps> = ({
  name,
  avatarUrl
}) => (
  <UserAvatar
    user={{
      name,
      profile_photo_url: avatarUrl
    }}
    size="md"
  />
);
